export default __webpack_public_path__ + "160ae3c3702dc900a158b58e5b305f38.svg";